const OLD_SIGNUP_PATTERN = /(^\/inscription\/)|(shine\.fr\/inscription)/;
const NEW_SIGNUP_PATTERN = /\/app\.shine\.fr\/register/;

/**
 * Does this URL match the pattern of the new previous /inscription/ route?
 */
const isSignupURL = (url?: string) =>
  !!url && (OLD_SIGNUP_PATTERN.test(url) || NEW_SIGNUP_PATTERN.test(url));

export default isSignupURL;
